<template>
  <div class="common-login-modal">
    <LoginModal
      v-if="loginDomain !== 'biz'"
      :theme="theme"
      @registerSuccess="registerSuccess"
      ref="loginModal"
    />
    <LoginModalBiz
      v-else
      :theme="theme"
      @registerSuccess="registerSuccess"
      ref="loginModal"
    />

    <GuideModal :theme="theme" ref="guideModal" @receiveSuccess="receiveSuccess" />
    <ReceiveSuccess ref="receiveSuccess" />
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import LoginModal from './LoginModal'
import LoginModalBiz from './LoginModalBiz'
import GuideModal from './GuideModal'
import ReceiveSuccess from './ReceiveSuccessModal'
import state from '../../../store/state'

export default {
  name: 'common-login-modal',
  components: {
    LoginModal,
    LoginModalBiz,
    GuideModal,
    ReceiveSuccess
  },
  props: {
    theme: VueTypes.oneOf(['blue', 'green']).def('blue')
  },
  data () {
    return {
      step: 1,
      logoinOptions: null
    }
  },
  computed: {
    loginDomain () {
      return state.loginDomain
    }
  },
  created () {
  },
  methods: {
    /**
     * @param {Object} option
     * @param {Function} option.success   登录成功回调
     * @param {Function} option.error     登录失败回调
     */
    showLogin (options) {
      this.logoinOptions = options
      this.$refs.loginModal.show(options)
    },
    hideLogin () {
      this.$refs.loginModal.hide()
    },
    /**
     * @param {Object} option
     * @param {Function} option.success   登录成功回调
     * @param {Function} option.error     登录失败回调
     */
    showGuide (options) {
      this.$refs.guideModal.show(options)
    },
    hideGuide () {
      this.$refs.guideModal.show()
    },
    showReceiveSuccess () {
      this.$refs.receiveSuccess.show()
    },
    /**
     * 如果是新用户
     */
    registerSuccess () {
      this.hideLogin()
      // this.showGuide(this.logoinOptions)
    },
    receiveSuccess () {
      this.showReceiveSuccess()
      // this.logoinOptions.success().then(() => {
      //   this.hideGuide()
      // })
      // 领取专栏成功，弹出关注公众号窗口
    }
  }
}
</script>
